import { Navigate, useLocation } from 'react-router-dom'
import { useAtom } from 'jotai'
import { Center, Loader } from '@mantine/core'
import { isAuthenticatedAtom, authHydratedAtom } from '../../atoms/authAtoms'

export function ProtectedRoute({ children }) {
  const [hydrated] = useAtom(authHydratedAtom)
  const [isAuthenticated] = useAtom(isAuthenticatedAtom)
  const location = useLocation()

  if (!hydrated) {
    return (
      <Center style={{ minHeight: '100vh' }}>
        <Loader size="lg" color="cyan" />
      </Center>
    )
  }

  if (!isAuthenticated) {
    // Stash the path the user was trying to reach so /login can send them
    // back after they authenticate (see consumeReturnTo() in useAuth).
    const currentPath = location.pathname + location.search
    if (currentPath !== '/' && currentPath !== '/login') {
      sessionStorage.setItem('bw_returnTo', currentPath)
    }
    return <Navigate to="/login" replace />
  }

  return children
}
